
import { defineComponent, onMounted, reactive } from "vue";

export default defineComponent({
  name: "SuccessfulModalCustom",
  props: {
    showModal: Boolean,
    titleMessage: String,
    subTitleMessage: String,
    isButton: {
            type: Boolean,
            default: false,
        },
        title:{
          type: String,
          default: 'Successfull'
        },
    hideCloseButton:{
      type:Boolean,
      default:false
    }
  },
  setup(props, { emit }) {
    // const router = useRouter();
    const state = reactive({
      data: {
        folderName: "",
        folderList: [] as any,
        folderTitle: "folder",
        folderHeading: "No folders created",
      },
      ui: {
        isActive: {
          customModal: false,
        },
        error: {
          hasError: false,
          errorList: {
            createNewFolder: [] as any,
            getFolderList: [] as any,
          },
        },
        isLoading: {
          getFolderList: false,
        },
        isPostLoading: {
          createNewFolder: false,
        },
      },
    });
    function closeSuccessfulModal() {
      emit("close");
      state.ui.isActive.customModal = false;
    }
    onMounted(() => {
      if (props.showModal) {
        state.ui.isActive.customModal = true;
      }
      //   getFolderList();
    });

    return {
      props,
      state,
      closeSuccessfulModal,
    };
  },
});
